import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/blog/images/blog.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/blog/images/blog1.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/blog/newblog.css");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
